import { actionCreator, propmtCodesActionTypes, checkHttpStatus, GET_PROMPT_CODES_LIST_API, GET_PROMPT_CODES_LIST_FORSETUP_API, GET_MASTERDATABYNAME, jsonApiHeader, POST_PROMPT_CODES_API, showErrorMessage, showSuccessMessage, showWarningMessage, DELETE_PROMPT_CODES_API, GET_PROMPT_CODES_DETAIL_API, GET_PROMPT_CODES_LIST_TO_COLLECTDATA_API } from '../constants/ApiConstants';
import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction';

export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(propmtCodesActionTypes.get_masterData.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        dispatch(actionCreator(propmtCodesActionTypes.get_masterData.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('error getMasterData ..', error);
      });
  };
};

export const getPromptCodeList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.REQUEST));
    fetch(`${GET_PROMPT_CODES_LIST_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.SUCCESS, response));
        } else {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_propmtCodesList', error);
      });
  };
};

export const getPromptCodeListForSetup = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.REQUEST));
    fetch(`${GET_PROMPT_CODES_LIST_FORSETUP_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.SUCCESS, response));
        } else {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_propmtCodesList', error);
      });
  };
};

export const getPatientPromptCodeListToCollectData = (searchObj, includeMasteredTargetsOnly) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.REQUEST));
    fetch(`${GET_PROMPT_CODES_LIST_TO_COLLECTDATA_API}${query_params}&includeMasteredTargetsOnly=${includeMasteredTargetsOnly}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.SUCCESS, response));
        } else {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesList.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_propmtCodesList', error);
      });
  };
};

export const getPromptCodeDetail = (propmtCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesDetail.REQUEST));
    fetch(`${GET_PROMPT_CODES_DETAIL_API}?promptCodeId=${propmtCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesDetail.SUCCESS, response));
        } else {
          dispatch(actionCreator(propmtCodesActionTypes.get_propmtCodesDetail.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_propmtCodesDetail', error);
      });
  };
};

export const savePromptCode = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(propmtCodesActionTypes.save_propmtCodes.REQUEST));
    fetch(`${POST_PROMPT_CODES_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(propmtCodesActionTypes.save_propmtCodes.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(propmtCodesActionTypes.save_propmtCodes.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error save_propmtCodes', error);
      });
  };
};

export const deletePromptCode = (propmtCodeId) => {
  Alert.closeAll();
  return (dispatch, getState) => {
    dispatch(actionCreator(propmtCodesActionTypes.delete_propmtCodes.REQUEST));
    fetch(`${DELETE_PROMPT_CODES_API}?promptCodeId=${propmtCodeId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(propmtCodesActionTypes.delete_propmtCodes.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(propmtCodesActionTypes.delete_propmtCodes.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(propmtCodesActionTypes.delete_propmtCodes.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error delete_propmtCodes', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/promptCodes/actions/PromptCodeActions.js